import axiosPrivate from "@services/axiosPrivate"
import { GET_PATIENT_COUNT } from "src/constants"

export const getPatientCount = (data) => {
  return axiosPrivate.get(GET_PATIENT_COUNT, {
    params: {
      ...data,
    },
  })
}
